import script from "./LkCmdLink.vue?vue&type=script&lang=js"
export * from "./LkCmdLink.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__